import { ApiService } from './index'
import { Measurement, ApiResponse } from '@types'

export const measurementsApi = {
  // Measurements
  getMeasurements: (params?: {
    hive_id?: number
    device_id?: number
    start?: string
    end?: string
    interval?: string
    limit?: number
    offset?: number
    sensor_definitions?: string[]
  }) =>
    ApiService.get<ApiResponse<Measurement[]>>('/measurements/', { params }),

  getMeasurement: (id: number) =>
    ApiService.get<ApiResponse<Measurement>>(`/measurements/${id}/`),

  // Hive measurements
  getHiveMeasurements: (hiveId: number, params?: {
    start?: string
    end?: string
    interval?: string
    limit?: number
    sensor_definitions?: string[]
  }) =>
    ApiService.get<ApiResponse<any>>(`/hives/${hiveId}/measurements/`, { params }),

  // Latest measurements
  getLatestMeasurements: (params?: {
    hive_id?: number
    device_id?: number
  }) =>
    ApiService.get<ApiResponse<any>>('/measurements/latest/', { params }),

  // Measurement statistics
  getMeasurementStats: (params?: {
    hive_id?: number
    device_id?: number
    start?: string
    end?: string
    interval?: string
  }) =>
    ApiService.get<ApiResponse<any>>('/measurements/stats/', { params }),

  // Export measurements
  exportMeasurements: (params?: {
    hive_id?: number
    device_id?: number
    start?: string
    end?: string
    format?: 'csv' | 'xlsx'
    sensor_definitions?: string[]
  }) =>
    ApiService.get('/measurements/export/', {
      params,
      responseType: 'blob'
    }),

  // Measurement aggregation (apps.measurements.views.MeasurementAggregatedView)
  getAggregatedMeasurements: (params: {
    sensor_type: string
    start_time: string
    end_time: string
    interval?: 'hour' | 'day' | 'week'
    device_id?: number
    hive_id?: number
  }) =>
    ApiService.get<ApiResponse<{
      sensor_type: string
      device_id: number | null
      hive_id: number | null
      start_time: string
      end_time: string
      min_value: number
      max_value: number
      avg_value: number
      count: number
      data_points: Array<{ timestamp: string; value: number | null; avg_value: number | null; min_value: number | null; max_value: number | null; count: number; window: string }>
    }>>('/measurements/aggregated/', { params }),

  // Weather data
  getWeatherData: (params: {
    latitude: number
    longitude: number
    start?: string
    end?: string
  }) =>
    ApiService.get<ApiResponse<any>>('/weather/', { params }),
}
